import React from 'react';
import AuthenticationContainer from './AuthenticationContainer';

export default function Message(props) {

    const {title, message} = props;

    return <AuthenticationContainer title={title}>
        {message}
    </AuthenticationContainer>;

}